import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown";
import { Button } from "@/components/ui/button";
import { Edit3, MoreHorizontal } from "lucide-react";

interface IProp {
  id: string;
  onOpenView?: () => void;
  onOpenDelete?: () => void;
  onOpenEdit?: () => void;
  setTransactionId?: (v: string) => void;
  setTerminalHealth?: () => void;
}
const TerminalHealthOptions = ({
  id,
  onOpenView,
  setTerminalHealth,
}: IProp) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Open menu</span>
          <MoreHorizontal />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="space-y-2 rounded-[10px] p-2" align="end">
        <DropdownMenuItem
          onClick={() => {
            onOpenView?.();
            setTerminalHealth?.();
          }}
          className="flex items-center gap-2 rounded-md bg-[#5B93FF] bg-opacity-5 p-2 text-[#5B93FF]"
        >
          <Edit3 size={16} />
          <span>View Terminal Health Details</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TerminalHealthOptions;
